import { ChevronRight } from "lucide-react";
import { formatSignedCaixaBalance } from "@/features/caixas/display";
import type { CaixaSupplierSummary } from "@/features/caixas/types";

interface CaixasSupplierSummaryCardProps {
  supplier: CaixaSupplierSummary;
  isSelected?: boolean;
  onOpenHistory: (supplier: CaixaSupplierSummary) => void;
}

function getBalanceColor(balance: number) {
  if (balance > 0) return "#16a34a";
  if (balance < 0) return "#ef4444";
  return "var(--login-muted)";
}

export function CaixasSupplierSummaryCard({
  supplier,
  isSelected = false,
  onOpenHistory,
}: CaixasSupplierSummaryCardProps) {
  return (
    <button
      type="button"
      className={`caixas-supplier-card${isSelected ? " caixas-supplier-card-selected" : ""}`}
      data-selected={isSelected ? "true" : undefined}
      onClick={() => onOpenHistory(supplier)}
    >
      <div className="caixas-supplier-card-main">
        <div className="caixas-supplier-card-copy">
          <span className="caixas-supplier-name">{supplier.name}</span>
        </div>
        <span className="caixas-supplier-last">
          {supplier.last_transaction
            ? new Intl.DateTimeFormat("pt-BR").format(
                new Date(supplier.last_transaction.created_at),
              )
            : "Sem movimentação"}
        </span>
        <div
          className="caixas-supplier-balance"
          style={{ color: getBalanceColor(supplier.box_balance) }}
        >
          {formatSignedCaixaBalance(supplier.box_balance)}
        </div>
        <span className="caixas-supplier-open-chevron" aria-hidden="true">
          <ChevronRight size={16} />
        </span>
      </div>
    </button>
  );
}
